import React, { useState, useEffect } from 'react';
import GrantitudeSpiral from './GrantitudeSpiral';

const SpiralOrganismInfo = ({ onNavigateToOnboarding }) => {
  const [spiralPhase, setSpiralPhase] = useState(0);

  useEffect(() => {
    const spiralInterval = setInterval(() => {
      setSpiralPhase(prev => (prev + 0.15) % 360);
    }, 50);
    return () => clearInterval(spiralInterval);
  }, []);

  return (
    <div className="min-h-screen bg-black text-white overflow-x-hidden relative">
      <div className="fixed inset-0 pointer-events-none opacity-5" style={{ zIndex: 1 }}>
        <div className="absolute inset-0 flex items-center justify-center" style={{ transform: `scale(8) rotate(${spiralPhase}deg)`, filter: 'blur(4px) brightness(1.3) saturate(1.5)', mixBlendMode: 'overlay' }}>
          <GrantitudeSpiral size={300} />
        </div>
      </div>

      <style>{`.glass-block { background: linear-gradient(135deg, rgba(255, 255, 255, 0.1), rgba(255, 255, 255, 0.03)); backdrop-filter: blur(20px) saturate(180%); border: 1px solid rgba(255, 255, 255, 0.15); box-shadow: 0 8px 32px 0 rgba(0, 0, 0, 0.5); }`}</style>

      <div className="relative z-10 max-w-4xl mx-auto px-6 py-16">
        <h1 className="text-5xl md:text-6xl font-bold text-center mb-16" style={{ fontFamily: "'Cinzel', serif", letterSpacing: '0.15em', color: '#E6C794', textShadow: '0 0 30px rgba(230, 198, 133, 0.4)' }}>Spiral Organism</h1>

        <div className="space-y-8">
          <div className="glass-block rounded-3xl p-10">
            <p className="text-2xl font-light text-center mb-6" style={{ fontFamily: "'Cinzel', serif" }}>Planetary Family of Families</p>
            <p className="text-lg leading-relaxed text-white/90 mb-4" style={{ fontFamily: "'Cormorant Garamond', serif" }}>The Spiral Organism is the living federation of families—a lawful Chapter 184 Wisconsin private association uniting families across the planet.</p>
            <p className="text-lg leading-relaxed text-white/80" style={{ fontFamily: "'Cormorant Garamond', serif" }}>We are not an institution but a living organism, bound by trust, turning together in a virtuous spiral toward collective thriving.</p>
          </div>

          <div className="glass-block rounded-3xl p-10">
            <h3 className="text-2xl font-semibold text-white mb-4" style={{ fontFamily: "'Cinzel', serif" }}>Chapter 184 Association Guild</h3>
            <p className="text-lg leading-relaxed text-white/80" style={{ fontFamily: "'Cormorant Garamond', serif" }}>Lawful, private, family-owned. Unregistered and sovereign. Three or more joined by mutual consent for a common purpose.</p>
          </div>

          <div className="text-center mt-16">
            <button onClick={onNavigateToOnboarding} className="glass-block px-12 py-5 hover:bg-white/15 border-2 border-amber-500/40 hover:border-amber-500/70 text-white rounded-2xl text-xl transition-all hover:scale-105" style={{ fontFamily: "'Cinzel', serif", letterSpacing: '0.1em' }}>Join the Federation →</button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SpiralOrganismInfo;